'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Sidebar } from '@/components/dashboard/Sidebar';
import { Navbar } from '@/components/dashboard/Navbar';
import { useAuth } from '@/lib/context/AuthContext';
import styles from '@/styles/dashboard.module.css';

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      router.replace('/login');
    }
  }, [loading, user, router]);

  if (loading || !user) {
    return <div className={styles.dashboardShell} />;
  }

  return (
    <div className={styles.dashboardShell}>
      <Sidebar />
      <div className={styles.dashboardMain}>
        <Navbar />
        <main className={styles.dashboardContent}>{children}</main>
      </div>
    </div>
  );
}
